import { render, staticRenderFns } from "./OrderDelete.vue?vue&type=template&id=108f2557&"
import script from "./OrderDelete.vue?vue&type=script&lang=js&"
export * from "./OrderDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('108f2557')) {
      api.createRecord('108f2557', component.options)
    } else {
      api.reload('108f2557', component.options)
    }
    module.hot.accept("./OrderDelete.vue?vue&type=template&id=108f2557&", function () {
      api.rerender('108f2557', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VPL/MyOrder/OrderDelete.vue"
export default component.exports